import { HYDRATE } from 'next-redux-wrapper';
import { THydrateAction } from '~/src/store';
import { IShopItem } from '~/src/api/content/shop/getShopItems';
import { IShopCategory } from '~/src/api/content/shop/getShopCategories';

export enum ECatalogActionTypes {
    SET_CART = 'CATALOG/SET_CART',
    FETCH_DATA = 'CATALOG/FETCH_DATA',
    ERROR = 'CATALOG/ERROR'
}

export enum ELabels {
    Hit = 'hit',
    New = 'new',
    Rek = 'rek'
}

export interface IShopItemByLabels {
    [ELabels.Hit]: (IShopItem | undefined)[],
    [ELabels.New]: (IShopItem | undefined)[],
    [ELabels.Rek]: (IShopItem | undefined)[],
}

export interface IGroupedShopItem extends IShopItem {
    count: number,
}

export interface ICatalogState {
    cart: IGroupedShopItem[],
    items: IShopItem[],
    itemsByLabel: IShopItemByLabels | null,
    categories: IShopCategory[],
    banners: any,
}

export const initialState: ICatalogState = {
    cart: [],
    items: [],
    categories: [],
    banners: [],
    itemsByLabel: {
        [ELabels.Hit]: [],
        [ELabels.New]: [],
        [ELabels.Rek]: [],
    },
};

export type TActions = {
    type: ECatalogActionTypes,
    payload: Partial<ICatalogState> | Record<string, unknown>,
};

const catalogReducer = (state = initialState, action: TActions | THydrateAction): ICatalogState => {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.catalog };
        case ECatalogActionTypes.SET_CART:
            return { ...state, ...action.payload };
        case ECatalogActionTypes.FETCH_DATA:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default catalogReducer;
